import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';

const DocumentUpload = ({ index, document, onDocumentChange, onRemoveDocument }) => {
  const [documentType, setDocumentType] = useState('');
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [existingFile, setExistingFile] = useState(null);

  useEffect(() => {
    if (document) {
      setDocumentType(document.documentType || '');
      setFileName(document.fileName || '');
      if (document.filePath) {
        setExistingFile(document.fileName || document.documentType);
      }
    }
  }, [document]);

  const handleDocumentTypeChange = (e) => {
    const { value } = e.target;
    setDocumentType(value);
    onDocumentChange(index, { ...document, documentType: value, file, fileName });
  };

  const handleFileChange = (e) => {
    const newFile = e.target.files[0];
    setFile(newFile);
    setExistingFile(null); // Clear existing file when new one is selected
    onDocumentChange(index, { ...document, documentType, file: newFile, fileName });
  };

  const handleFileNameChange = (e) => {
    const { value } = e.target;
    setFileName(value);
    onDocumentChange(index, { ...document, documentType, file, fileName: value });
  };

  return (
    <Row className="mb-3 align-items-center">
      <Col md={4}>
        <Form.Group>
          <Form.Select value={documentType} onChange={handleDocumentTypeChange} required>
            <option value="">-- Select Document Type --</option>
            <option value="Challan">Challan</option>
            <option value="Eway">E-way Bill</option>
            <option value="E-invoice">E-invoice</option>
            <option value="Other">Other</option>
          </Form.Select>
        </Form.Group>
      </Col>
      {documentType === 'Other' && (
        <Col md={3}>
          <Form.Group>
            <Form.Control
              type="text"
              placeholder="Enter document name"
              value={fileName}
              onChange={handleFileNameChange}
              required
            />
          </Form.Group>
        </Col>
      )}
      <Col md={documentType === 'Other' ? 4 : 7}>
        {existingFile ? (
          <div className="d-flex align-items-center">
            <span className="me-2 text-truncate" title={existingFile}>{existingFile}</span>
            <Button variant="outline-secondary" size="sm" onClick={() => {
              setExistingFile(null);
              // Notify parent that file is being replaced
              onDocumentChange(index, { ...document, documentType, file: null, fileName, _fileChanged: true });
            }}>Change</Button>
          </div>
        ) : (
          <Form.Group>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              accept=".pdf,.jpg,.jpeg,.png"
              required={!document} // Only required for new documents
            />
          </Form.Group>
        )}
      </Col>
      <Col md={1}>
        <Button variant="danger" size="sm" onClick={() => onRemoveDocument(index)}>
          ✕
        </Button>
      </Col>
    </Row>
  );
};

export default DocumentUpload;
